import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          kicker="主题分类"
          title="按你关心的方向找瓜"
          description="六个常设栏目覆盖从明星动向到幕后制作的常见话题，每个栏目下的时间线都按更新时间排序。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/timeline?category=${cat.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-bold text-background-400 transition-colors group-hover:text-accent-500">
                  {cat.count}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
              <span className="mt-4 inline-flex items-center gap-1 font-label text-xs text-primary-600">
                查看该栏目
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}